<template>
  <div
    class="lp-collapse-item"
    :class="[active && 'lp-collapse-item-expanded', simple && 'simple']"
  >
    <div
      class="lp-collapse-item-title"
      :class="simple && 'simple'"
      :aria-expanded="active"
      @click="!precise && (active = !active)"
    >
      <div class="ly-row ly-center-center">
        <lp-icon
          v-if="switchIcon"
          class="lp-collapse-item-title-icon"
          :name="active ? 'chevron-down' : 'chevron-right'"
          @click="precise && (active = !active)"
        />
        <span>
          <span class="ly-col" v-html="title" />
          <slot name="helper" />
        </span>
        <slot name="secondaryActions" />
      </div>
      <div>
        <slot name="primaryActions" />
        <lp-icon
          v-if="!switchIcon"
          class="lp-collapse-item-title-icon"
          :name="active ? 'chevron-down' : 'chevron-right'"
          @click="precise && (active = !active)"
        />
      </div>
    </div>
    <transition name="drop-bottom">
      <div
        v-show="active"
        class="lp-collapse-item-body"
        :class="simple && 'simple'"
      >
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'

export default defineComponent({
  name: 'lp-collapse-item',
  props: {
    title: { type: String },
    opened: { type: Boolean },
    simple: { type: Boolean },
    precise: { type: Boolean },
    switchIcon: { type: Boolean, default: false },
  },
  setup(props) {
    const active = ref(props.opened)
    return { active }
  },
})
</script>
